module.exports = {"150522100":"甘旗卡镇","150522101":"吉尔嘎朗镇","150522102":"金宝屯镇","150522103":"常胜镇","150522104":"查日苏镇","150522105":"双胜镇","150522106":"阿古拉镇","150522107":"朝鲁吐镇","150522108":"努古斯台镇","150522109":"海鲁吐镇","150522200":"阿都沁苏木","150522201":"茂道吐苏木","150522202":"巴嘎塔拉苏木","150522203":"散都苏木","150522204":"巴彦毛都苏木","150522400":"胜利农场","150522401":"孟根达坝牧场","150522402":"查金台牧场","150522403":"原种场","150522404":"大青沟管理局","150522405":"哈日乌苏种畜场","150522406":"乌兰敖道渔场","150522407":"金宝屯林场","150522408":"朝鲁吐林场","150522409":"茂道吐林场","150522410":"伊胡塔林场","150522411":"乌旦塔拉林场"}


//////////////////
// WEBPACK FOOTER
// ./src/town/150522.json
// module id = 517
// module chunks = 0